module.exports = function () {
    // global functionality goes here

    const $body = $('body'),
        $header = $('header.masthead'),
        $searchInput = $('.masthead__search-bar input'),
        classSearchbarVisible = 'masthead--show-search-bar';

    $body.addClass('jsenabled');


    // check if browser is IE - if true, add body class
    const isIE = navigator.appName === 'Microsoft Internet Explorer' ||
        !!(navigator.userAgent.match(/Trident/) ||
            navigator.userAgent.match(/rv:11/)) ||
        (typeof $.browser !== "undefined" && $.browser.msie === 1);

    if (isIE) {
        $body.addClass('browser-ie');
    }


    // check if browser is Safari - if true, add body class
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (isSafari) {
        $body.addClass('browser-safari');
    }


    // push gtm-event data-values on anchors to datalayer
    $body.on('click', '[data-gtm-event]', function () {
        let gtm_event = $(this).data('gtm-event');
        let page_url = $(location).attr('href');

        // console.log({'dbk_category' : 'click_event', 'dbk_event' : gtm_event, 'dbk_url' : page_url }); // development

        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({ 'dbk_category': 'click_event', 'dbk_event': gtm_event, 'dbk_url': page_url }); // production
        }
    });


    // prevent disabled buttons to execute default actions
    $('.btn-disabled').click(function (e) {
        e.preventDefault();
    });


    // unfocus links after click
    $body.on('click', 'a, button', function () {
        $(this).blur();
    });


    // init lightbox
    $('a.lightbox').nivoLightbox({
        afterShowLightbox: function () {
            let $iframe = $('.nivo-lightbox-content > iframe'),
                src = $iframe.attr('src');

            $iframe.attr('src', src + '?autoplay=1&rel=0&disablekb=1&fs=0');
        }
    }).each(function () {
        // if src is a youtube embed url then convert it to video url (in movie galleries)
        let $link = $(this),
            src = $link.attr('href'),
            videoID;

        if (typeof src !== 'undefined') {

            if (src.indexOf('youtu') > -1 && src.indexOf('embed') > -1) {
                let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
                let match = src.match(regExp);

                if (match && match[7].length === 11) {
                    videoID = match[7];
                } else if (match && match[7].length === 10) { // regex strips first char if it is v
                    videoID = 'v' + match[7];
                } else {
                    $link.remove();
                }

                $link.attr('href', 'https://www.youtube.com/watch?v=' + videoID);
            }
        }
    });


    // // init tooltips
    // $body.tooltip({
    //     selector: '[data-toggle="tooltip"]',
    //     container: 'body'
    // });

    // // init popovers
    // $body.popover({
    //     // trigger: 'click',
    //     selector: '[data-toggle="popover"]',
    //     trigger: 'hover',
    //     html: true,
    //     template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    // });


    // when a link is clicked with href attribute starting with #, scroll that shit smoothly (if target exists)
    $('a[href^="#"]').click(function (e) {
        
        let $this = $(this);
        let target = $(this).attr('href');
        let scrollOffset = 0;
        
        if(target.length <= 1) {
            return;
        }

        e.preventDefault();

        if (viewport().width > 991) {
            scrollOffset = $header.outerHeight();
        }

        if ($this.data('extra-scroll-offset')) {
            scrollOffset = scrollOffset + $(this).data('extra-scroll-offset');
        }

        // if target exists
        if ($(target).length > 0) {

            // if target has top margin, add half of it to scroll offset
            let targetMargin = parseInt($(target).css('marginTop'));

            if (targetMargin > 0) {
                scrollOffset = scrollOffset + (targetMargin / 2);
            }

            $('html, body').animate({
                scrollTop: $(target).stop().offset().top - scrollOffset
            }, 1000, 'easeInOutCubic', function () {
                $this.blur();
            });
        }
    });


    // disable hero-video with URL variable
    if (window.location.search.indexOf('no_video=1') >= 0) {
        $('.section__background-video').remove();
    }


    // insert sub-menu icons in main-nav
    $('.nav-bar__main .menu > .menu-item.menu-item-has-children > a').each(function () {
        $(this).append('<div class="menu-item__icon"><i class="far fa-angle-down"></i></div>');
    });
    $('.nav-bar__main .menu > .menu-item .sub-menu > .menu-item > a').each(function () {
        $(this).append('<div class="sub-menu__icon"><i class="far fa-angle-right"></i></div>');
    });

    // insert check icon elements to ul.list-checked in content-wrapper
    $('.content-wrapper .list-checked > li').each(function () {
        $(this).prepend('<i class="item-icon far fa-check"></i>');
    });


    // wrap table elements inside .content areas in .table-wrapper div
    $('.content table').each(function () {
        $(this).wrap('<div class="table-wrapper"></div>');
    });


    // overview-header video - audio toggle
    $('.section__background-video .audio-toggle').on('click', function (e) {
        e.preventDefault();

        let $toggle = $(this),
            $wrapper = $toggle.closest('.section__background-video'),
            classToggled = 'audio-toggle--sound-on';

        // check if youtube or vimeo
        if ($wrapper.attr('class').indexOf('youtube') >= 0) {
            // video is youtube
            // toggling sound is handled in iframe api script code

            if ($toggle.hasClass(classToggled)) {
                $toggle.removeClass(classToggled);
            } else {
                $toggle.addClass(classToggled);
            }
        } else if ($wrapper.attr('class').indexOf('vimeo') >= 0) {
            // video is vimeo

            let $player = $wrapper.find('video.player__inner');

            if ($toggle.hasClass(classToggled)) {
                $toggle.removeClass(classToggled);
                $player.prop('muted', true);
            } else {
                $toggle.addClass(classToggled);
                $player.prop('muted', false);
            }
        }

        $toggle.blur();
    });


    // formatting pretty post-dates with moment-js
    $('[data-datetime]').each(function (i, e) {
        let time = moment.unix($(e).data('datetime'));
        $(e).html(time.fromNow());
    });


    // toggle-search
    $('#toggle-search').click(function (e) {
        e.preventDefault();

        if ($header.hasClass(classSearchbarVisible)) {
            $header.removeClass(classSearchbarVisible);
            $searchInput.blur();
        } else {
            let xPosition = $(window).scrollTop();

            $header.addClass(classSearchbarVisible);
            $searchInput.focus();
            $(window).scrollTop(xPosition); // disable focus 'jump'

            $body.trigger('show-search');
        }
    });

    // if escape key is pressed, close search
    $(document).keyup(function (e) {
        if (e.keyCode == 27) {
            if ($header.hasClass(classSearchbarVisible)) {
                $header.removeClass(classSearchbarVisible);
                $searchInput.blur();
            }
        }
    });

    $body.on('show-menu', function () {
        if ($header.hasClass(classSearchbarVisible)) {
            $header.removeClass(classSearchbarVisible);
            $searchInput.blur();
        }
    });


    // DBK cookie law settings toggle
    $body.on('click', '#dbk-cookie-law .btn-show-cookie-setting', function () {
        let $toggle = $(this),
            $settings = $(this).closest('#dbk-cookie-law').find('.cookies-notification__bottom'),
            classToggled = 'btn-show-cookie-setting--toggled';

        if ($toggle.hasClass(classToggled)) {
            $toggle.removeClass(classToggled);
            $settings.stop().slideUp(150);
        } else {
            $toggle.addClass(classToggled);
            $settings.stop().slideDown(150);
        }
    });


    $('.global-quick-links').on('click', function () {
        let $links = $(this);

        if (viewport().width < 992) {
            $links.addClass('global-quick-links--visible');
        }

        setTimeout(function () {
            $links.removeClass('global-quick-links--visible');
        }, 5000);
    });


    // show/hide mobile filters
    $('.filters-mobile__toggle').on('click', function () {
        let $filters = $(this).closest('.filters-mobile'),
            classFiltersVisible = 'filters-mobile--visible',
            bodyClassFiltersVisible = 'show-mobile-filters';

        if ($filters.hasClass(classFiltersVisible)) {
            $filters.removeClass(classFiltersVisible);
            $body.removeClass(bodyClassFiltersVisible);
        } else {
            $body.addClass(bodyClassFiltersVisible);
            $filters.addClass(classFiltersVisible);
        }
    });


    // load extra JS parts
    require('./youtube.js');
    require('./gravity-forms.js');
    require('./custom-form-elements.js');
    require('./etalage.js');
    require('./sliders.js');
    require('./popups.js');
    require('./tabs.js');
    require('./menu-overlay.js');
    require('./open-hours.js');
    require('./expandable-items.js');
    require('./responsive-video.js');
    require('./copy-to-clipboard.js');
    require('./booking-form.js');
    require('./sticky-nav-bar.js');
    require('./modals.js');
    require('./video.js');

};